import React, { useState } from 'react'
import Form from './Form'

const BinStoreForm = () => {
  const [isSubscribed, setIsSubscribed] = useState(false)

  if (isSubscribed)
    return (
      <div className="bg-[#132C52] w-full px-4 mx-auto text-center py-16">
        <p className="text-white text-[16px] mb-5 md:text-[24px] text-center font-extrabold max-w-3xl py-4 pt-8 mx-auto">
          THANKS FOR SIGNING UP!
        </p>
      </div>
    )

  return (
    <div className="bg-[#132C52]">
      <div className="max-w-[1440px] px-4 mx-auto text-center py-16">
        <h2 className="text-[36px] md:text-[48px] font-extrabold text-[#F5F5F5]">
          Stay Updated
        </h2>
        <p className="text-[#FECE62] text-[16px] md:text-[24px] font-medium max-w-3xl py-4 pt-8 mx-auto">
          Sign up for overstock bin updates
        </p>
        <Form onSuccess={() => setIsSubscribed(true)} />
        <div className="max-w-[600px] mx-auto text-center md:text-left pt-2 md:pt-2 flex justify-center md:justify-start">
          <a
            className="text-[#F5F5F5] text-[12px] font-bold cursor-pointer"
            href="/privacy-policy"
          >
            Privacy Policy
          </a>
          <span className="text-[#F5F5F5] text-[12px] font-bold cursor-pointer px-2">
            |
          </span>
          <a
            className="text-[#F5F5F5] text-[12px] font-bold cursor-pointer"
            href="/pages/terms"
          >
            Terms & Conditions
          </a>
        </div>
      </div>
    </div>
  )
}
export default BinStoreForm
